// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3XdBC","colMaxWidth":"Table_colMaxWidth__3O04e"};